module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.sbstatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "sbstatus", $$v)
      },
      expression: "params.sbstatus"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "全部数据"
    }
  }, [_vm._v("全部数据")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "全部上报"
    }
  }, [_vm._v("全部上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "部分上报"
    }
  }, [_vm._v("部分上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "未上报"
    }
  }, [_vm._v("未上报")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省局"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入省局名称模糊查询"
    },
    model: {
      value: (_vm.params.pname),
      callback: function($$v) {
        _vm.$set(_vm.params, "pname", $$v)
      },
      expression: "params.pname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "省局",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sbstatus",
      "label": "状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "出版单位数量",
      "width": "190",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nonum",
      "label": "未上报数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wsnum",
      "label": "待审",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ysnum",
      "label": "已审",
      "align": "center"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e590ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/adminDzauditQuery.vue
// module id = 1735
// module chunks = 1